export default __webpack_public_path__ + "static/media/a1.23b36d1a.png";